import { TCType, type RoastingEvent, type TCSettings } from '$lib/types/RoastLog';

export const DEFAULT_ROASTER_SETTINGS: TCSettings = {
  '1': {
    name: 'Bean',
    show: true,
    color: '#A63D40',
    phidget: {
      type: 89,
      channel: 0,
      hubPort: 0
    },
    offset: 0,
    active: true,
    type: TCType.J,
    id: 1
  },
  '2': {
    name: 'Environment',
    show: true,
    color: '#E9C46A',
    phidget: {
      type: 89,
      channel: 1,
      hubPort: 0
    },
    plotRoR: false,
    offset: 0,
    active: true,
    type: TCType.J,
    id: 2
  },
  '3': {
    name: '',
    show: false,
    color: '#70AE6E',
    phidget: {
      channel: 2,
      hubPort: 0
    },
    offset: 0,
    active: false,
    type: TCType.J,
    id: 3
  },
  '4': {
    name: '',
    show: true,
    color: '#516A92',
    phidget: {
      channel: 3,
      hubPort: 0
    },
    offset: 0,
    active: false,
    type: TCType.J,
    id: 4
  }
};

export const DEFAULT_GAS_ROASTING_EVENT: RoastingEvent = {
  name: 'Gas',
  type: 'equipment',
  scale: {
    min: '0',
    max: '100',
    step: '10'
  }
};

export const DEFAULT_AIR_ROASTING_EVENT: RoastingEvent = {
  name: 'Air',
  type: 'equipment',
  scale: {
    min: '0',
    max: '100',
    step: '10'
  }
};

export enum DeviceType {
  PHIDGETS = 'phidgets',
  PHIDGETS_RTD = 'phidgets_rtd',
  SIVETZ = 'sivetz',
  RLBTLE = 'rlbtle',
  RLUSB = 'rlusb',
  LORING = 'loring',
  FAKE = 'fake',
  DIEDRICH = 'diedrich',
  COFFEE_TECH = 'coffee_tech',
  SAN_FRANCISCAN = 'san_franciscan',
  SAN_FRANCISCAN_RTU = 'san_franciscan_rtu',
  PRIMO = 'primo',
  COFFED_SR30 = 'coffed_sr30',
  COFFED_MODBUS = 'coffed_modbus',
  YOSHAN_RTU = 'yoshan_rtu'
}

// Legacy enum for backward compatibility - consider removing in future
export enum DeviceTypeLabel {
  PHIDGETS = 'Phidgets',
  SIVETZ = 'Sivetz',
  RLBTLE = 'Bluetooth',
  RLUSB = 'USB',
  LORING = 'Loring',
  FAKE = 'Simulator'
}

export type DeviceSelection = {
  label: string;
  value: DeviceType;
};
